import React from 'react';
import cx from 'classnames';
import InputProps from './Input.types';
import styles from './Input.module.scss';
import Icon from '../Icon';

const Input = ({
  name,
  value,
  type = 'text',
  onChange,
  dataPointer,
  placeholder,
  dataCy = 'input',
  id,
  invalid,
  disabled,
  errorMsgHolderId,
  controlled = false,
  className = '',
  style = {},
  onFocus = () => {},
  onBlur = () => {},
  onKeyDown = () => {},
  onKeyUp = () => {},
  color = 'primary',
  inputRef,
  autoComplete = 'on',
  label,
  labelledBy,
  ariaProps,
  icon,
  iconProps,
  char = null,
  iconCharHorizontalPosition = 'left',
}: InputProps) => {
  const valueProp: {
    value?: string | number | readonly string[];
    defaultValue?: string | number | readonly string[];
  } = {};
  if (controlled) {
    valueProp.value = value || '';
  } else {
    valueProp.defaultValue = value;
  }

  const input = (
    <input
      {...valueProp}
      style={style}
      name={name}
      type={type}
      className={cx(
        styles.input,
        styles[color],
        {
          [styles.invalid]: invalid,
        },
        className,
        icon || char ? styles['input-indent'] : null,
        iconCharHorizontalPosition === 'right' ? styles['input-right-direction'] : null
      )}
      aria-label={label}
      aria-labelledby={labelledBy}
      onChange={onChange}
      data-pointer={dataPointer}
      placeholder={placeholder}
      disabled={disabled}
      id={id}
      data-lpignore
      aria-invalid={invalid}
      aria-errormessage={errorMsgHolderId}
      data-testid='input'
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      ref={inputRef}
      autoComplete={autoComplete}
      data-cy={dataCy}
      {...ariaProps}
    />
  );

  return !icon ? (
    input
  ) : (
    <div
      style={{
        display: 'flex',
        position: 'relative',
        flexDirection: `${iconCharHorizontalPosition === 'right' ? 'row-reverse' : 'row'}`,
        ...style,
      }}>
      {char ? (
        <div
          style={{ width: '1.355rem', height: '1.1355rem' }}
          className={cx(styles['vertical-center'], styles['char-container'])}>
          <div className={cx(styles.char)}>{char.substring(0, 1)}</div>
        </div>
      ) : (
        <Icon
          dataCy={`${dataCy}-${icon}`}
          icon={icon}
          className={cx(styles.spinner, className, styles['vertical-center'], styles.icon)}
          viewBox='0 0 1024 1024'
          fill='currentColor'
          styleProps={{ width: '1.355rem', height: '1.1355rem' }}
          {...iconProps}
        />
      )}
      {input}
    </div>
  );
};

export default Input;
